import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=8e71bab0&scoped=true"
import script from "./SocialSharing.vue?vue&type=script&lang=js"
export * from "./SocialSharing.vue?vue&type=script&lang=js"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&id=8e71bab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e71bab0",
  null
  
)

export default component.exports